"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetupsMap = void 0;
const Mapper_1 = require("../../core/infra/Mapper");
const ESetupTarget_1 = require("../domain/valueObjects/enums/ESetupTarget");
const SetupItemMap_1 = require("./SetupItemMap");
const Setups_1 = require("../domain/valueObjects/Setups");
const GenericMap_1 = require("./GenericMap");
const utils_1 = require("../../core/infra/utils");
class SetupsMap extends Mapper_1.Mapper {
    static toDomain(raw, ref, runValidation) {
        if (runValidation) {
            if (!Setups_1.Setups.validate(raw, ref).pass)
                return null;
        }
        const domainObject = !raw
            ? null
            : Setups_1.Setups.create({
                data: utils_1.mapIndexed(raw.data, SetupItemMap_1.SetupItemMap.toDomain),
                type: ESetupTarget_1.ESetupTarget.create(raw.type),
            });
        return domainObject;
    }
    static toDTO(d) {
        const res = GenericMap_1.GenericMap.toDTO(d);
        return res;
    }
}
exports.SetupsMap = SetupsMap;
//# sourceMappingURL=SetupsMap.js.map